import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {IDialogComponent} from "../../dialog/iDialog.component";
import {DrawingOnImageDialogOutput} from "../../drawing/drawing-on-image-dialog/drawing-on-image-dialog.component";
import {DialogWithInput} from "../../dialog/dialogWithInput";
import {DialogModule} from "../../dialog/dialog.module";
import {
  DrawingOnImageChangedEvent,
  DrawingOnImageComponent, DrawingOptions
} from "../../drawing/drawing-on-image/drawing-on-image.component";
import {DrawingData} from "../../drawing/drawing-on-image/drawingOnImageDrawingElement.model";
import {
  VideoAnalysisCategoriesData,
  VideoAnalysisCategoriesDataCategory, VideoAnalysisCategoriesDataCategoryOptions
} from "../video-analysis/video-analysis.component";
import {SelectElementV2} from "../../../../components/common/select/selectElementV2";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SelectFilterV2Component} from "../../../../components/common/select-filter-v2/select-filter-v2.component";

export class VideoAnalysisImageDrawingDialogInput {
  backgroundUrl: string;
  categoriesData: VideoAnalysisCategoriesData;
  drawingData: DrawingData;
  categoryName: string;
}

export interface VideoAnalysisImageDrawingDialogOutput {
  drawingData: DrawingData;
  image: string;
  categoryName: string;
}

@Component({
  selector: 'app-video-analysis-image-drawing-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, DrawingOnImageComponent, SelectFilterV2Component],
  templateUrl: './video-analysis-image-drawing-dialog.component.html',
  styles: [
  ]
})
export class VideoAnalysisImageDrawingDialogComponent implements IDialogComponent<VideoAnalysisImageDrawingDialogInput, VideoAnalysisImageDrawingDialogOutput>, OnInit {
  dialog: DialogWithInput<VideoAnalysisImageDrawingDialogInput, VideoAnalysisImageDrawingDialogOutput>;

  image: string;
  drawingData: DrawingData;
  options: DrawingOptions;
  categoryElements: SelectElementV2<VideoAnalysisCategoriesDataCategory>[] = [];

  formGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.formGroup = this.formBuilder.group({
      categoryName: this.formBuilder.control(undefined, [Validators.required]),
    })
  }

  ngOnInit() {
    if (this.dialog.input.categoriesData) {
      if (this.dialog.input.categoriesData.categories?.length > 0) {
        this.categoryElements = this.dialog.input.categoriesData.categories.map(value => new SelectElementV2<VideoAnalysisCategoriesDataCategory>(value.name, value.label, value));

        let category;
        if (this.dialog.input.categoryName) {
          category = this.dialog.input.categoriesData.categories.find(value => value.name === this.dialog.input.categoryName);
        }
        if (! category) {
          category = this.dialog.input.categoriesData.categories[0];
        }
        this.formGroup.patchValue({
          categoryName: category.name
        });
        this.selectedCategoryChanged(category);
      }

    }

  }

  selectedCategoryChanged(category: VideoAnalysisCategoriesDataCategory) {
    this.options = undefined;
    if (category) {
      this.options = {
        options: category.options.map(value => {
          return {
            label: value.label,
            name: value.name,
            element: value.element,
            subType: value.subType,
            size: value.size,
            thickness: value.thickness,
            color: value.color
          }
        })
      };
    }
  }

  changed(event: DrawingOnImageChangedEvent) {
    console.log('event changed', event);
    this.image = event?.image;
    this.drawingData = event?.data;
  }

  close() {
    this.dialog.close({
      image: this.image,
      drawingData: this.drawingData,
      categoryName: this.formGroup.value.categoryName
    } as VideoAnalysisImageDrawingDialogOutput);
  }

}
